import React from 'react';
import { Button } from 'rsuite';
import { BiLinkExternal } from 'react-icons/bi';
import styles from './CadastroRangeDePrecosContent.module.scss';

type CadastroRangeDePrecosContentProps = {
  onClickDownloadModel?: () => void;
};

export const CadastroRangeDePrecosContent = ({ onClickDownloadModel }: CadastroRangeDePrecosContentProps) => {
  return (
    <>
      <h2 className={styles.title}>Cadastro de range de preços</h2>

      <div className={styles.content}>
        <p className={styles.subtitle}>
          Os ranges cadastrados serão utilizados para mostrar, no painel de aderência, se os preços estão dentro ou fora do range e seus detalhamentos.
        </p>
        <h4 className={styles['product-list-title']}>Quais produtos incluir na minha lista?</h4>
        <p>
          Uma lista de produtos de aderência de preços é composta por itens estratégicos usados para monitorar se redes e lojas estão praticando preços
          competitivos e alinhados ao mercado, ou respeitando o range de preços definidos pela estratégia.
        </p>
        <p className={styles.description}>Para garantir uma análise mais precisa e relevante, cadastre o seu sortimento próprio completo.</p>
        <div className={styles['bottom-description-wrapper']}>
          <p className={styles['description-no-margin']}>
            A aderência de preços será calculada com base na lista de produtos enviada por meio do arquivo abaixo.
          </p>
          <p className={styles['description-no-margin']}>Para atualizar os dados exibidos no painel, basta enviar uma nova versão da lista.</p>
        </div>
        <p className={styles.description}>
          <Button appearance="link" className={styles.link} onClick={onClickDownloadModel}>
            <BiLinkExternal color="#0066cc" style={{ marginRight: '4px', marginBottom: '-2px' }} />
            Baixe o modelo de arquivo .xlsx
          </Button>
        </p>
      </div>
    </>
  );
};
